import { IBaseAxiosResponse } from "../Helper/IAxios";

export interface IReportEmailSettings {
  ReceiveFileReportEmail: boolean
  FileReportPeriodicity: ReportPeriodicityEnum
  ReceiveTopicReportEmail: boolean
  TopicReportPeriodicity: ReportPeriodicityEnum
  ReceivePlottReportEmail: boolean
  PlottReportPeriodicity: ReportPeriodicityEnum
}

export interface IRequestReportEmailSettings {
  receiveFileReportEmail: boolean
  fileReportPeriodicity: ReportPeriodicityEnum
  receiveTopicReportEmail: boolean
  topicReportPeriodicity: ReportPeriodicityEnum
  receivePlottReportEmail: boolean
  plottReportPeriodicity: ReportPeriodicityEnum
}

export enum ReportPeriodicityEnum {
  Weekly = 1,
  Daily = 2
}

export interface IReportAxiosResponse extends IBaseAxiosResponse<IReportEmailSettings> { }

export interface IReportCreateAxiosResponse extends IBaseAxiosResponse<null> { }

export interface IReportUpdateAxiosResponse extends IBaseAxiosResponse<null> { }
